import PropTypes from 'prop-types';
import FeedPostBlur from './FeedPostBlur';
import Flux from '../../flux/Flux';
import FeedPostNeedAction from './FeedPostNeedAction';
import { VXPay } from '../../utils/VXPay';
import Slider, { DOT_POSITION, DOT_STYLE, ARROW_POSITION, CONTROL_VISIBILITY, PAGINATION_POSITION } from '../VXSlider/VXSlider';
import { tippingGoalType } from './FeedHelper';
import FeedPostNeedsTippingGoal from './FeedPostNeedsTippingGoal';
import { generateKey } from '../../utils/CommonUtils';
import UrlBuilder from '../../utils/UrlBuilder';
import { PureComponent } from 'react';

const doubleTime = 200;

class FeedPostAlbumSlider extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			currentImage: this.getCurrentImage(),
			clientWidth: 0,
		};

		this.clickTimer;
		this.liked = false;
		this.likedSet = false;
		this.sliderWrapper = null;
		this.resizeObserver = new ResizeObserver((entries) => {
			if (entries[0].contentRect.width !== this.state.clientWidth) {
				this.onWindowResize();
			}
		});

		this.toggleFullscreen = this.toggleFullscreen.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onDbClick = this.onDbClick.bind(this);
		this.onIndexChange = this.onIndexChange.bind(this);
		this.onDoubleTouch = this.onDoubleTouch.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
		this.onTouch = this.onTouch.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addWindowResizeListener(this.onWindowResize);
	}

	componentDidUpdate() {
		this.setNewWidth();
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.onWindowResize);

		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	}

	onWindowResize() {
		this.setNewWidth();
	}

	setNewWidth() {
		const newState = {};

		if (this.sliderWrapper && this.state.clientWidth !== this.sliderWrapper.clientWidth) {
			newState.clientWidth = this.sliderWrapper.clientWidth;
		}

		this.setState({ ...newState });
	}

	getCurrentImage() {
		if (!this.props.imageId || this.props.isSingleImage) {
			return 0;
		}
		return this.props.photos.findIndex((item) => item.id === this.props.imageId);
	}

	toggleFullscreen() {
		this.props.isOverlay
			? Flux.Feed.toggleOverlay(this.props.id)
			: Flux.Feed.toggleOverlay(this.props.id, Flux.Constants.Feed.OverlayTypes.ALL, this.props.photos[this.state.currentImage].id);
	}

	onIndexChange(index) {
		this.setState({ currentImage: index });
	}

	getImageSizes() {
		let sizes = '320px';
		if (!this.props.isMobile) {
			if (this.props.isOverlay) {
				sizes = '1100px';
			} else {
				sizes = '800px';
			}
		}
		return sizes;
	}

	getSlider() {
		const photos = [this.props.photos[this.props.photos.length - 1], ...this.props.photos, this.props.photos[0]];
		const needsTippingGoal = this.props.tippingGoal && !this.props.tippingGoal.achieved;

		return (
			<div className="feed-slider__container">
				<div className="feed-slider__item-wrapper">
					{photos.map((photo, index) => (
						<div className="feed-slider__item" key={generateKey(index)}>
							<FeedPostBlur imgUrl={this.props.photos[this.state.currentImage].url} isOverlay={this.props.isOverlay} />
							{!photo.avsRequired && (
								<img
									className="feed-slider__image"
									srcSet={this.props.photos[this.state.currentImage].srcSet}
									sizes={this.getImageSizes()}
								/>
							)}
							{photo.avsRequired && (
								<FeedPostNeedAction poster={this.props.photos[this.state.currentImage].url} actorId={parseInt(this.props.actorId)} />
							)}
							{needsTippingGoal && <FeedPostNeedsTippingGoal {...this.props} />}
						</div>
					))}
				</div>
			</div>
		);
	}

	preventScroll(e) {
		if (e.cancelable) {
			e.preventDefault();
		}
	}

	onDbClick() {
		if (Flux.Guest.isLoggedIn() && !this.props.isMobile && !this.props.isTablet) {
			clearTimeout(this.clickTimer);
			Flux.Feed.toggleLike(this.props.id);
		}
	}

	onClick(e) {
		if ((e.detail === 1 && !Flux.Browser.isTouch()) || e.key === 'Enter') {
			if (this.props.type === Flux.Constants.Feed.Types.CONTEST) {
				e.preventDefault();
				window.location.href =
					UrlBuilder.buildContestDetailRoute(this.props.contest.id) + '?mediaIndex=' + this.props.photos[this.state.currentImage].id;
			} else {
				this.clickTimer = setTimeout(() => {
					this.toggleFullscreen();
				}, doubleTime);
			}
		}
	}

	getPhoto(currentImage) {
		const clk = (e) => {
			if (!Flux.Guest.isLoggedIn()) {
				VXPay.openSignupOrLogin();
			} else if (!this.props.isMobile && !this.props.isTablet) {
				this.onClick(e);
			}
		};
		return (
			<div className="feed-slider__item" key={generateKey(currentImage.id)}>
				<FeedPostBlur imgUrl={currentImage.url} isOverlay={this.props.isOverlay} />
				{!currentImage.avsRequired && (
					<img
						className="feed-slider__image"
						srcSet={currentImage.srcSet}
						onClick={clk}
						tabIndex={0}
						onKeyDown={(e) => e.key === 'Enter' && clk(e)}
						onDoubleClick={this.props.isMobile || this.props.isTablet ? null : this.onDbClick}
						sizes={this.getImageSizes()}
					/>
				)}
				{currentImage.avsRequired && <FeedPostNeedAction poster={currentImage.url} actorId={parseInt(this.props.actorId)} />}
			</div>
		);
	}

	onTouch() {
		Flux.Guest.isLoggedIn() && !this.props.isOverlay && this.toggleFullscreen();
	}

	onDoubleTouch() {
		Flux.Guest.isLoggedIn() && Flux.Feed.toggleLike(this.props.id);
	}

	setSliderRef(ref) {
		if (ref) {
			this.sliderWrapper = ref;
			this.resizeObserver.observe(this.sliderWrapper);
			if (this.sliderWrapper.clientWidth !== this.state.clientWidth) {
				this.setState({ clientWidth: this.sliderWrapper.clientWidth });
			}
		}
	}

	render() {
		const themeConfig = {
			showMessenger: !this.props.isMobile,
		};

		const content = this.props.photos.map((photo) => this.getPhoto(photo));

		const sliderStyling = {
			pagination: {
				styleClass: '',
				mobile: {
					show: CONTROL_VISIBILITY.ALWAYS,
					position: this.props.isOverlay ? PAGINATION_POSITION.LEFT : PAGINATION_POSITION.RIGHT,
				},
				tablet: {
					show: CONTROL_VISIBILITY.ALWAYS,
					position: this.props.isOverlay ? PAGINATION_POSITION.LEFT : PAGINATION_POSITION.RIGHT,
				},
				desktop: {
					show: this.props.isOverlay ? CONTROL_VISIBILITY.ALWAYS : CONTROL_VISIBILITY.HOVER,
					position: PAGINATION_POSITION.RIGHT,
				},
			},
			dots: {
				styleClass: '',
				mobile: {
					show: CONTROL_VISIBILITY.ALWAYS,
					position: DOT_POSITION.INSIDE,
					style: DOT_STYLE.DYNAMIC,
				},
				tablet: {
					show: CONTROL_VISIBILITY.ALWAYS,
					position: DOT_POSITION.INSIDE,
					style: DOT_STYLE.DYNAMIC,
				},
				desktop: {
					show: this.props.isOverlay ? CONTROL_VISIBILITY.ALWAYS : CONTROL_VISIBILITY.HOVER,
					position: DOT_POSITION.INSIDE,
					style: DOT_STYLE.EQUAL,
				},
			},
			arrows: {
				styleClass: '',
				mobile: {
					show: CONTROL_VISIBILITY.HIDDEN,
					position: ARROW_POSITION.INSIDE,
				},
				tablet: {
					show: CONTROL_VISIBILITY.ALWAYS,
					position: ARROW_POSITION.INSIDE,
				},
				desktop: {
					show: this.props.isOverlay ? CONTROL_VISIBILITY.ALWAYS : CONTROL_VISIBILITY.HOVER,
					position: ARROW_POSITION.INSIDE,
				},
			},
		};

		return (
			<div className="feed-slider" ref={(ref) => this.setSliderRef(ref)}>
				<div className={'feed-slider__wrapper'}>
					<Slider
						onIndexChange={this.onIndexChange}
						mobileBreakpoint={Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm}
						sliderContent={content}
						themeConfig={themeConfig}
						challenges={[...content]}
						challengeWrapper={this.sliderWrapper ? { current: this.sliderWrapper } : null}
						isFullWidth={true}
						useSwipe={(this.props.isTablet || this.props.isMobile) && !this.props.isSingleImage}
						onDoubleTouch={this.onDoubleTouch}
						doubleTime={this.doubleTime}
						useKeyNav={this.props.isOverlay}
						initIndex={this.state.currentImage}
						maxTileWidth={this.props.isSingleImage && this.sliderWrapper ? this.state.clientWidth : null}
						isOverlay={this.props.isOverlay}
						isTablet={this.props.isTablet}
						isMobile={this.props.isMobile}
						onTouch={this.onTouch}
						{...sliderStyling}
					/>
				</div>

				{this.props.isOverlay && (this.props.isMobile || this.props.isTablet) && (
					<i className={'feed-slider__fullscreen feed-slider__fullscreen--close icon -icon-close-line'} onClick={this.toggleFullscreen}></i>
				)}
			</div>
		);
	}
}

FeedPostAlbumSlider.propTypes = {
	photos: PropTypes.array,
	isSingleImage: PropTypes.bool,
	isOverlay: PropTypes.bool,
	isMobile: PropTypes.bool,
	isTablet: PropTypes.bool,
	id: PropTypes.string,
	liked: PropTypes.bool,
	imageId: PropTypes.string,
	actorId: PropTypes.string,
	tippingGoal: PropTypes.shape(tippingGoalType),
	type: PropTypes.string,
	contest: PropTypes.object,
};

export default FeedPostAlbumSlider;
